import * as IconSelector from '../icons';

export const tiposVino = [
    {
        value: 'Tinto',
        label: 'Tinto',
        description: 'Tinto',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Roble',
        label: 'Roble',
        description: 'Roble',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Barrica',
        label: 'Barrica',
        description: 'Barrica',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Crianza',
        label: 'Crianza',
        description: 'Crianza',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Reserva',
        label: 'Reserva',
        description: 'Reserva',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Gran Reserva',
        label: 'Gran Reserva',
        description: 'Gran Reserva',
        icon: IconSelector.PointIcon,
        color: 'DarkRed'
    },
    {
        value: 'Rosado',
        label: 'Rosado',
        description: 'Rosado',
        icon: IconSelector.PointIcon,
        color: 'LightRed'
    },
    {
        value: 'Blanco',
        label: 'Blanco',
        description: 'Blanco',
        icon: IconSelector.PointIcon,
        color: 'Gold'
    },
    {
        value: 'Dulce',
        label: 'Dulce',
        description: 'Dulce',
        icon: IconSelector.PointIcon,
        color: 'BLack'
    },
    {
        value: 'Vino Licor',
        label: 'Vino Licor',
        description: 'Vino Licor',
        icon: IconSelector.PointIcon,
        color: 'Grey'
    }
];
